export * from 'react-native-web'
import React from 'react'
import { NativeModules as WebNativeModules, Platform as WebPlatform } from 'react-native-web'

export const Platform = {
  ...WebPlatform,
  constants: {
    ...WebPlatform.constants,
    reactNativeVersion: { major: 0, minor: 79, patch: 5 },
  },
}

export const ViewPropTypes = {
  style: () => {},
}

export const requireNativeComponent = () => {}

export const NativeModules = {
  ...WebNativeModules,
  Configuration: {},
  RNShare: {},
  SourceCode: {
    scriptURL: '',
  },
  RNViewShot: {},
}

export default React
